export default {"src":"/login-app/[GIT_HASH]/_next/static/media/backfill.c4223518.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};